<div class="div flex flex-row items-center">
    <input type="checkbox" [disabled]="isDisabled" [checked]="value" [disabled]="isDisabled"
        (change)="onInputChange($event)" (blur)="handleBlur()"
        class="rounded my-auto outline-none ring-0 focus:outline-none focus:ring-0">
    @if (label) {
    <span class="ml-2">{{ label }}</span>
    }
</div>